<template>
  <div class="footerNavPanel">
    <div class="content12 item-none" >
      <img style="width: 2.23rem" src="@/images/title/contactUs.png" />
      <div class="meetingDetailsPanel flex-start-start">
        <div class="meetingAddressPanel">
          <div class="meetingAddressTitle flex-center-center">
            <img
              class="meetingAddressIcon"
              src="@/images/com/address_orange_icon.png"
              alt
            />
            <span class="meetingDetailsText">会议地点</span>
            <div class="meetingAddressContent meetingDetailsContent">
              中国·深圳 大中华喜来登酒店
            </div>
          </div>
        </div>
        <div class="meetingTimePanel">
          <div class="meetingTimeTitle flex-center-start">
            <img
              class="meetingTimeIcon"
              src="@/images/com/time_orange_icon.png"
              alt
            />
            <span class="meetingDetailsText">会议时间</span>
            <div class="meetingTimeContent meetingDetailsContent">2021/12/10</div>
          </div>
        </div>
      </div>
      <div class="footerContactUs">
        <colorBox
          class="colorBox"
          :bgurl="require('@/images/home/contact_us_bgi.png')"
        >
          <div class="comHomeContentPanel">
            <cooperation />
          </div>
        </colorBox>
      </div>
    </div>
    <div class="keep-on-record">
      版权所有：深圳市游迷天下科技有限公司 | 法律声明
      <a target="_blank" href="http://beian.miit.gov.cn/">粤ICP备13090461号</a>
    </div>
  </div>
</template>

<script>
import titleBox from "@/components/titleBox.vue";
import cooperation from "@/components/cooperation.vue";
import colorBox from "@/components/colorBox.vue";
export default {
  components: {
    titleBox,
    cooperation,
    colorBox,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.footerNavPanel {
  width: 100%;
  padding: 0.6rem 0;
  background: linear-gradient(60deg, #010412 0%, #400104 100%);
  backdrop-filter: saturate(180%) blur(6px);
  -webkit-backdrop-filter: saturate(180%) blur(6px);
  -moz-backdrop-filter: saturate(180%) blur(6px);
  -o-backdrop-filter: saturate(180%) blur(6px);
  .meetingDetailsPanel {
    padding: 0.4rem 0;
  }
  .meetingAddressPanel {
    padding-right: 0.82rem;
  }

  .meetingAddressIcon {
    width: 0.14rem;
    height: 0.16rem;
  }
  .meetingTimeIcon {
    width: 0.16rem;
    height: 0.16rem;
  }
  .meetingDetailsText {
    font-size: 0.16rem;
    font-weight: 400;
    color: #fff;
    padding: 0 0.2rem 0 0.08rem;
  }

  .meetingDetailsContent {
    font-size: 0.14rem;
    color: rgba(255, 255, 255, 0.6);
  }
  .sutpContentPanel {
    max-width: 11.24rem;
  }
  .sutpIem {
    background: rgba(98, 0, 21, 1);
    backdrop-filter: saturate(180%) blur(6px);
    border: 1px solid #b61c22;
  }
  .frosted-background {
    width: 11.24rem !important;
    height: 4.7rem !important;
    padding: 0.35rem;
  }
  .keep-on-record {
    margin-top: 0.6rem;
  }
  .colorBox {
    background-size: 12.4rem 5.9rem !important;
    padding: 0.1rem 0 0 0.1rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com/black/footerNav.vue